<template>
  <AttachmentPreviewContainer
    type="Gift Card"
    :title="attachment.data.balanceLabel"
    :info="attachment.data.customNumber"
    icon="giftCard"
    @remove="$emit('remove')"
  />
</template>

<script setup lang="ts">
import AttachmentPreviewContainer from '../../preview/Container.vue'

interface Props {
  attachment: Record<string, any>
}

defineProps<Props>()

const emit = defineEmits<{
  (e: 'remove'): void
}>()
</script>
